module.exports = __webpack_public_path__ + "img/plus_price_icon1_mobile.b201baf4.png";